module.exports = __webpack_public_path__ + "static/media/icon_service_email.cc520546.svg";